import type { BlockList } from 'shared-types';

type LocaleData = BlockList['locales'][string];

const defaultBlockData = {
  format: 'html' as const
};

const defaultOrderedListHtml =
  '<ol style="list-style-type:decimal"><li><p></p></li></ol>';

const defaultUnorderedListHtml =
  '<ul style="list-style-type:disc"><li><p></p></li></ul>';

const translatable: LocaleData['translatable'] = {
  listHtml: ''
};
const defaultLocaleData: LocaleData = { translatable };

const localePlaceholders = {
  listHtml: '{{ locales.translatable.listHtml }}' as const
};

export const defaults = {
  defaultBlockData,
  defaultLocaleData,
  defaultOrderedListHtml,
  defaultUnorderedListHtml,
  localePlaceholders
};

export const blockListData: BlockList = {
  ...defaultBlockData,
  ...localePlaceholders,
  locales: new Proxy({} as BlockList['locales'], {
    get: (locales, languageVersion: string) => {
      return (locales[languageVersion] = defaultLocaleData);
    }
  })
};
